export default "__VITE_ASSET__BHIef6w4__"